import script from "./chart_coinlist_kibotZone.vue?vue&type=script&setup=true&lang=js"
export * from "./chart_coinlist_kibotZone.vue?vue&type=script&setup=true&lang=js"

import "./chart_coinlist_kibotZone.vue?vue&type=style&index=0&id=ec7de46e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec7de46e"]])

export default __exports__